export default "__VITE_ASSET__b72054bc__"